import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function ComparisonSection() {
  const {
    t
  } = useLanguage();
  const scrollToForm = () => {
    document.getElementById('lead-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const bad = [t('comp.bad.1'), t('comp.bad.2'), t('comp.bad.3'), t('comp.bad.4'), t('comp.bad.5')];
  const good = [t('comp.good.1'), t('comp.good.2'), t('comp.good.3'), t('comp.good.4'), t('comp.good.5')];
  return <section className="py-14 md:py-20 bg-[#f4f4f4]" data-track="comparison" data-id="element-12">
      <div className="container mx-auto px-5 md:px-6" data-id="element-13">
        <div className="text-center mb-10 md:mb-14" data-id="element-14">
          <motion.h2 className="text-2xl md:text-4xl font-black text-[#111111] uppercase tracking-tight mb-2" initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-15">
            {t('comp.title')}{' '}
            <span className="text-[#C41230]" data-id="element-16">{t('comp.name')}</span>
            {t('comp.titleEnd')}
          </motion.h2>
          <p className="text-[#6b6b6b] text-sm md:text-base" data-id="element-17">{t('comp.sub')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 max-w-4xl mx-auto" data-id="element-18">
          <motion.div className="bg-red-50/60 border border-red-100 rounded-xl p-5 md:p-8" initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} data-id="element-19">
            <h3 className="text-sm md:text-lg font-bold text-red-700 mb-4 flex items-center gap-2" data-id="element-20">
              <span className="bg-red-100 p-1 rounded text-xs" data-id="element-21">🚫</span>
              {t('comp.bad.title')}
            </h3>
            <ul className="space-y-2.5 md:space-y-3" data-id="element-22">
              {bad.map((p, i) => <li key={i} className="flex items-center gap-2.5 text-[#6b6b6b] text-sm md:text-base" data-id="element-23">
                  <X className="w-4 h-4 text-red-400 flex-shrink-0" data-id="element-24" />
                  <span data-id="element-25">{p}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div className="bg-white border-2 border-[#C41230]/30 rounded-xl p-5 md:p-8 shadow-lg relative" initial={{
          opacity: 0,
          x: 15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} data-id="element-26">
            <div className="absolute top-0 right-0 bg-[#C41230] text-white text-[10px] md:text-xs font-bold px-2.5 py-0.5 rounded-bl-lg uppercase tracking-wider" data-id="element-27">
              {t('comp.recommended')}
            </div>
            <h3 className="text-sm md:text-lg font-bold text-[#111111] mb-4 flex items-center gap-2" data-id="element-28">
              <span className="text-[#C41230]" data-id="element-29">✓</span>
              {t('comp.good.title')}
            </h3>
            <ul className="space-y-2.5 md:space-y-3" data-id="element-30">
              {good.map((p, i) => <li key={i} className="flex items-center gap-2.5 text-[#111111] font-medium text-sm md:text-base" data-id="element-31">
                  <Check className="w-4 h-4 text-[#C41230] flex-shrink-0" data-id="element-32" />
                  <span data-id="element-33">{p}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <div className="mt-8 md:mt-12 text-center" data-id="element-34">
          <button onClick={scrollToForm} data-track-cta="comparison-cta" className="btn-primary py-3.5 px-8 md:py-4 md:px-10 rounded-md text-sm md:text-base" data-id="element-35">
            {t('comp.cta')}
          </button>
        </div>
      </div>
    </section>;
}